/**
 * Returns an array of resources..
 * @param {*} schedule
 */
const generateGroups = (schedule) => {
  const resources = [];
  if (schedule) {
    for (let resource of schedule) {
      if (resource.rId && resource.name) {
        try {
          const group = {
            id: resource.rId,
            title: resource.name,
            empCat: resource.empCat,
            class: resource.class
          };
          resources.push(group);
        } catch (e) {
          console.err(e);
        }
      }
    }
    
    return (resources);
  } else return resources;
}

export default generateGroups;
